import * as React from 'react';

interface InfinitySvgProps {
    width?: number;
    height?: number;
    className?: string;
}

export const InfinitySvg: React.FC<InfinitySvgProps> = ({
    width = 16,
    height = 16,
    className = '',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M2.00002 8.00004C2.00002 6.71137 3.04469 5.66671 4.33335 5.66671C5.13569 5.66671 5.67975 5.95591 6.13278 6.40895C6.61702 6.89317 6.99009 7.55484 7.41722 8.32377L7.43969 8.36417C7.84035 9.08557 8.29542 9.90491 8.92442 10.534C9.59642 11.2059 10.469 11.6667 11.6667 11.6667C13.6918 11.6667 15.3334 10.0251 15.3334 8.00004C15.3334 5.97499 13.6918 4.33337 11.6667 4.33337C10.5596 4.33337 9.56722 4.82397 8.89489 5.59962C9.19249 6.03608 9.43829 6.47055 9.64269 6.83831C10.0454 6.13816 10.801 5.66671 11.6667 5.66671C12.9554 5.66671 14 6.71137 14 8.00004C14 9.28871 12.9554 10.3334 11.6667 10.3334C10.8644 10.3334 10.3203 10.0442 9.86729 9.59111C9.38302 9.10691 9.00995 8.44524 8.58282 7.67631L8.56035 7.63591C8.15969 6.91451 7.70462 6.09514 7.07562 5.46613C6.40363 4.79417 5.53102 4.33337 4.33335 4.33337C2.30831 4.33337 0.666687 5.97499 0.666687 8.00004C0.666687 10.0251 2.30831 11.6667 4.33335 11.6667C5.44039 11.6667 6.43284 11.1761 7.10515 10.4004C6.80755 9.96397 6.56177 9.52951 6.35739 9.16177C5.95465 9.86191 5.19906 10.3334 4.33335 10.3334C3.04469 10.3334 2.00002 9.28871 2.00002 8.00004Z"
                fill="#3A3247"
            />
        </svg>
    );
};
